import ApiClient from '../ApiClient';

class CrmDealsAPI extends ApiClient {
    constructor() {
        super('crm/deals', { accountScoped: true });
    }

    move(dealId, stageId, position) {
        return axios.post(`${this.url}/${dealId}/move`, {
            stage_id: stageId,
            position,
        });
    }

    getConversations(dealId) {
        return axios.get(`${this.url}/${dealId}/conversations`);
    }

    linkConversation(dealId, conversationId) {
        return axios.post(`${this.url}/${dealId}/link_conversation`, {
            conversation_id: conversationId,
        });
    }

    unlinkConversation(dealId, conversationId) {
        return axios.delete(`${this.url}/${dealId}/unlink_conversation`, {
            params: { conversation_id: conversationId },
        });
    }

    getByPipeline(pipelineId, filters = {}) {
        const params = { pipeline_id: pipelineId };
        Object.keys(filters).forEach(key => {
            if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                params[key] = filters[key];
            }
        });
        return axios.get(this.url, { params });
    }

    getByPipelineIds(pipelineIds, filters = {}) {
        const params = { 'pipeline_ids[]': pipelineIds };
        Object.keys(filters).forEach(key => {
            if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                params[key] = filters[key];
            }
        });
        return axios.get(this.url, { params });
    }

    getActivities(dealId) {
        return axios.get(`${this.url}/${dealId}/activities`);
    }

    getStageDurations(dealId) {
        return axios.get(`${this.url}/${dealId}/stage_durations`);
    }

    getAiCalls(dealId) {
        return axios.get(`${this.url}/${dealId}/ai_calls`);
    }

    getFormSubmissions(dealId) {
        return axios.get(`${this.url}/${dealId}/form_submissions`);
    }

    getDealsByContact(contactId) {
        return axios.get(this.url, { params: { contact_id: contactId } });
    }

    bulkAction(payload) {
        const baseUrl = this.url.replace('/crm/deals', '/crm/deal_bulk_actions');
        return axios.post(baseUrl, payload);
    }
}
export default new CrmDealsAPI();
